<template>
  <div
    v-if="schoolArtikelen && schoolArtikelen.length"
    class="content-block"
  >
    <h3 class="content-block-title">
      Artikelen over deze school
    </h3>
    <ol>
      <li
        v-for="artikel in schoolArtikelen"
        :key="artikel.guid"
      >
        <a
          target="_blank"
          :href="artikel.guid"
        >{{ artikel.title }}</a>
      </li>
    </ol>
  </div>
</template>
<script>
import postsRepository from '@/repositories/postsRepository';

export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      schoolArtikelen: [],
    };
  },
  created() {
    this.loadSchoolArtikelen();
  },
  methods: {
    loadSchoolArtikelen() {
      postsRepository.listPostsByBrins([this.school.brin]).then(({ data }) => {
        const schoolArtikelen = data[this.school.brin];
        if (schoolArtikelen && schoolArtikelen.length) {
          this.schoolArtikelen = schoolArtikelen;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
ol {
  list-style-type: none;
  padding-left: 0;
  margin: 0px;

  li {
    margin-bottom: 8px;
  }
}
</style>
